import Vue from 'vue'
import Router from 'vue-router'
import { i18n } from './i18n.js'

Vue.use(Router)

export default new Router({
  mode: 'history',  
  base: '/',
  routes: [
    {
      path: '/optimaw/:lang',
      name: 'optimaw',
      components: {
        appToolbar: () => import('@/components/OptimaToolbar.vue'),
        appContent: () => import('@/components/OptimaContent.vue')
      },
      beforeEnter(to, from, next)
      {
        const lang=to.params.lang;
        if (!['de','fr','en'].includes(lang))
          return next('/pl/de');
        if (i18n.locale !== lang)
          i18n.locale=lang;
        return next();
      }
    }
  ]

})
